import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mb-10" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h2", { class: "anchor fw-bolder mb-5" }, [
  /*#__PURE__*/_createVNode("a", { href: "#autosize-textarea" }),
  /*#__PURE__*/_createTextVNode(" Autosize Textarea ")
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "py-5" }, [
  /*#__PURE__*/_createTextVNode(" Setting the "),
  /*#__PURE__*/_createVNode("code", null, "autosize"),
  /*#__PURE__*/_createTextVNode(" prop for a textarea type of Input makes the height to automatically adjust based on the content. An options object can be provided to "),
  /*#__PURE__*/_createVNode("code", null, "autosize"),
  /*#__PURE__*/_createTextVNode(" to specify the minimum and maximum number of lines the textarea can automatically adjust. ")
], -1)
const _hoisted_4 = { class: "rounded border p-10" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { style: {"margin":"20px 0"} }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")
  const _component_CodeHighlighter = _resolveComponent("CodeHighlighter")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode("div", _hoisted_4, [
      _createVNode(_component_el_input, {
        type: "textarea",
        autosize: "",
        placeholder: "Please input",
        modelValue: _ctx.textarea1,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.textarea1 = $event))
      }, null, 8, ["modelValue"]),
      _hoisted_5,
      _createVNode(_component_el_input, {
        type: "textarea",
        autosize: { minRows: 2, maxRows: 4 },
        placeholder: "Please input",
        modelValue: _ctx.textarea2,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.textarea2 = $event))
      }, null, 8, ["modelValue"]),
      _createVNode(_component_CodeHighlighter, {
        "field-height": 400,
        lang: "html"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.code7), 1)
        ]),
        _: 1
      })
    ])
  ]))
}